import t from '@guestyci/localize/t.macro';
import { string } from '@guestyci/arc';

export const buildPasswordSchema = (email, firstName, lastName, ruleMap) => {
  const emailLocal = email ? email.toLowerCase().split('@')[0] : '';
  const firstNameLower = firstName ? firstName.toLowerCase() : '';
  const lastNameLower = lastName ? lastName.toLowerCase() : '';
  const minLen = ruleMap.minLength ?? 8;
  const errorMsg = {
    message: t("Password doesn't meet the requirements below."),
  };

  let pw = string.min(minLen, errorMsg);

  if (ruleMap.hasNumber) pw = pw.regex(/\d/, errorMsg);
  if (ruleMap.hasLowercase) pw = pw.regex(/[a-z]/, errorMsg);
  if (ruleMap.hasUppercase) pw = pw.regex(/[A-Z]/, errorMsg);
  if (ruleMap.hasSymbol) pw = pw.regex(/[^a-zA-Z0-9\s]/, errorMsg);

  if (ruleMap.noEmail && emailLocal) {
    pw = pw.refine(val => !val.toLowerCase().includes(emailLocal), errorMsg);
  }
  if (ruleMap.noFirstName && firstNameLower) {
    pw = pw.refine(
      val => !val.toLowerCase().includes(firstNameLower),
      errorMsg
    );
  }
  if (ruleMap.noLastName && lastNameLower) {
    pw = pw.refine(val => !val.toLowerCase().includes(lastNameLower), errorMsg);
  }

  return pw;
};
